import { render } from "./PublicationPage.vue?vue&type=template&id=0f265bee"
import script from "./PublicationPage.vue?vue&type=script&lang=ts"
export * from "./PublicationPage.vue?vue&type=script&lang=ts"
script.render = render

export default script